import Head from "next/head";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useEffect } from "react";
import ReactGA from "react-ga";
import { useRouter } from "next/router";
import axiosInstance from "../../config/axios";
import Layout from "../../components/Layout";
import sanitize from "../../helpers/sanitize";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    
  },
  heading: {
    fontSize: "15px !important",
    fontWeight: theme.typography.fontWeightRegular,
    color: "#383838 !important",
  },
}));

const Faq = ({ faqs }) => {
  const classes = useStyles();

  const createMarkup = (html) => ({ __html: sanitize(html) });

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const router = useRouter();
  const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;

  return (
    <Layout>
      <Head>
      <link rel="canonical" href={canonicalUrl} />
        <title>Kilimanjaro FAQs | Orders, Delivery & More </title>
        <meta
						name='description'
						content='Find answers to frequently asked questions about Kilimanjaro orders, food delivery, pickup, payments, restaurant locations, and other customer services.'
					/>

					<meta name='keyword' content='MEALS FOOD RESTAURANT NIGERIA' />
      </Head>
      <header className="store-header tandc"></header>
      <section className="contact-us store-location about">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h4>Frequently Asked Questions</h4>
            </div>
            <div className="col-md-10 mx-auto">
              <div className={classes.root}>
                {faqs.map((faq) => {
                  return (
                    <Accordion key={faq.id}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className={classes.heading}>
                          {faq.question}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          <div
                            dangerouslySetInnerHTML={createMarkup(faq.answer)}
                          ></div>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

Faq.getInitialProps = async () => {
  try {
    const {
      data: { data },
    } = await axiosInstance.get("faqs");
    return { faqs: data };
  } catch (error) {
    // console.log(error);
    return { faqs: [] };
  }
};

export default Faq;
